export const validateuser = (fields) => {
  const isValid = {};

  if (fields?.AdharCard === '') {
    isValid.AdharCard = 'Field is require';
  }
  if (fields?.AdvanceLieuCompanyExpenses === '') {
    isValid.AdvanceLieuCompanyExpenses = 'Field is require';
  }
  if (fields?.Allowance === '') {
    isValid.Allowance = 'Field is require';
  }
  if (fields?.Arrears === '') {
    isValid.Arrears = 'Field is require';
  }
  if (fields?.Bank === '') {
    isValid.Bank = 'Field is require';
  }
  if (fields?.BankAccountNumber === '') {
    isValid.BankAccountNumber = 'Field is require';
  }
  if (fields?.Bonus === '') {
    isValid.Bonus = 'Field is require';
  }
  if (fields?.City === '') {
    isValid.City = 'Field is require';
  }
  if (fields?.CompanyCreditCardUsage === '') {
    isValid.CompanyCreditCardUsage = 'Field is require';
  }
  if (fields?.CreatedAt === '') {
    isValid.CreatedAt = 'Field is require';
  }
  if (fields?.Deductions === '') {
    isValid.Deductions = 'Field is require';
  }
  if (fields?.Designation === '') {
    isValid.Designation = 'Field is require';
  }

  if (fields?.ESOPs === '') {
    isValid.ESOPs = 'Field is require';
  }
  if (fields?.EmployeeEmailId === '') {
    isValid.EmployeeEmailId = 'Field is require';
  } else if (!/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/.test(fields?.EmployeeEmailId)) {
    isValid.EmployeeEmailId = 'Enter a valid Email';
  }
  if (fields?.EmployeeID === '') {
    isValid.EmployeeID = 'Field is require';
  }

  if (fields?.EmployeeOutstanding === '') {
    isValid.EmployeeOutstanding = 'Field is require';
  }
  if (fields?.EmployeeRiskCategory === '') {
    isValid.EmployeeRiskCategory = 'Field is require';
  }
  if (fields?.Employer === '') {
    isValid.Employer = 'Field is require';
  }
  if (fields?.EmployerRiskCategory === '') {
    isValid.EmployerRiskCategory = 'Field is require';
  }
  if (fields?.EmployerType === '') {
    isValid.EmployerType = 'Field is require';
  }
  if (fields?.EmploymentStatus === '') {
    isValid.EmploymentStatus = 'Field is require';
  }

  if (fields?.FixedSalary === '') {
    isValid.FixedSalary = 'Field is require';
  }
  if (fields?.FixedVariableSalary === '') {
    isValid.FixedVariableSalary = 'Field is require';
  }

  if (fields?.GrossSalary === '') {
    isValid.GrossSalary = 'Field is require';
  }
  if (fields?.IFSCNumber === '') {
    isValid.IFSCNumber = 'Field is require';
  }
  if (fields?.LoanEMIFromCompany === '') {
    isValid.LoanEMIFromCompany = 'Field is require';
  }
  if (fields?.LOPDays === '') {
    isValid.LOPDays = 'Field is require';
  }
  if (fields?.LossOfPayDays === '') {
    isValid.LossOfPayDays = 'Field is require';
  }
  if (fields?.LastDateOfEmployment === '') {
    isValid.LastDateOfEmployment = 'Field is require';
  }
  if (fields?.Month === '') {
    isValid.Month = 'Field is require';
  }
  if (fields?.Name === '') {
    isValid.Name = 'Field is require';
  }
  if (fields?.NetSalary === '') {
    isValid.NetSalary = 'Field is require';
  }
  if (fields?.NoticePeriod === '') {
    isValid.NoticePeriod = 'Field is require';
  }

  if (fields?.OnSabbatical === '') {
    isValid.OnSabbatical = 'Field is require';
  }
  if (fields?.OnProbation === '') {
    isValid.OnProbation = 'Field is require';
  }
  if (fields?.Overtime === '') {
    isValid.Overtime = 'Field is require';
  }
  if (fields?.PanNumber === '') {
    isValid.PanNumber = 'Field is require';
  }
  if (fields?.Paydays === '') {
    isValid.Paydays = 'Field is require';
  }
  if (fields?.PhoneNumber === '') {
    isValid.PhoneNumber = 'Field is require';
  } else if (fields?.PhoneNumber.length !== 10) {
    isValid.PhoneNumber = 'Enter a valid phone number with a maximum of 10 digits';
  }
  if (fields?.ProbationPeriod === '') {
    isValid.ProbationPeriod = 'Field is require';
  }
  if (fields?.Reimbursements === '') {
    isValid.Reimbursements = 'Field is require';
  }
  if (fields?.RelocationExpenses === '') {
    isValid.RelocationExpenses = 'Field is require';
  }
  if (fields?.ResignationDate === '') {
    isValid.ResignationDate = 'Field is require';
  }
  if (fields?.SabbaticalPeriod === '') {
    isValid.SabbaticalPeriod = 'Field is require';
  }
  if (fields?.Terminated === '') {
    isValid.Terminated = 'Field is require';
  }
  if (fields?.YearEndSettlements === '') {
    isValid.YearEndSettlements = 'Field is require';
  }
  if (fields?.YearOfJoining === '') {
    isValid.YearOfJoining = 'Field is require';
  }

  return isValid;
};
